import { EventEmitter, Injectable } from '@angular/core';
import { DossierDto, DossierSearchResultDto } from '@scip/api';

@Injectable({
  providedIn: 'root'
})
export class DossierService {
  refreshSubmissionsTable: EventEmitter<any> = new EventEmitter();

  openDossierEchaLinks(dossiers: Array<DossierSearchResultDto | DossierDto>): void {
    dossiers
      .filter((d) => d.reportUrl)
      .forEach((d) => {
        let openUrl: string = d.reportUrl;

        // ECHA changed their reportUrls, but did not updated their spec, so for now
        // we will remove the legal entity uuid in the report url and then handle it like an old report url
        if (openUrl.toLowerCase().includes('?leUuid='.toLowerCase())) {
          openUrl = openUrl.substring(0, openUrl.toLowerCase().indexOf('?leUuid='.toLowerCase()));
        }

        if (d.status === 'VALIDATION_FAILED') {
          openUrl = openUrl + '/validation-report?leUuid=' + d.org.echaLegalId;
        } else {
          openUrl = openUrl + '?leUuid=' + d.org.echaLegalId;
        }
        window.open(openUrl, '_blank');
      });
  }

  triggerRefreshSubmissionsTable(): void {
    this.refreshSubmissionsTable.emit();
  }
}
